import { Auth0Provider } from "@auth0/auth0-react";
import React from "react";
import { useNavigate } from "react-router-dom";

export const Auth0ProviderWithNavigate = ({ children }) => {
  const navigate = useNavigate()
  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;

  const onRedirectCallback = (appState) => {
    // hash router appends the path after the query string params. So not using navigate() and using window.location.href. 
    // navigate(appState.returnTo)
    window.location.href = `${window.location.origin}/#${appState.returnTo}`
  };

  if (!(domain && clientId)) {
    return null;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        audience: process.env.REACT_APP_AUTH0_API_AUDIENCE,
        redirect_uri: `${window.location.origin}/#/callback`,
      }}
      onRedirectCallback={onRedirectCallback}
      cacheLocation='localstorage'
    >
      {children}
    </Auth0Provider>
  );
};